import { searchColorBooks } from '../../api/color-books.api';
import { SearchColorBooksApiRequest } from '../../../../types/requests/color-books/search-color-books.request';
import { useAxiosInfiniteQuery } from './use-axios.hook';

const baseQueryKey = 'color-book';
const searchQueryKey = 'search';

export const useSearchColorBooks = (params: SearchColorBooksApiRequest) => {
  const { data, ...result } = useAxiosInfiniteQuery({
    queryKey: [baseQueryKey, searchQueryKey, params],
    queryFn: async ({ pageParam }) => (await searchColorBooks({ cursor: pageParam, ...params })).data,
    initialPageParam: params.cursor,
    getNextPageParam: (lastResponse) => lastResponse.nextCursor,
  });
  return { ...result, response: data } as const;
};
